// src/ConsumerApp/api/offers/discounts.service.js
import { apiClient } from '../apiClient';

export const DiscountService = {
  getDiscountsByCustomer: async (customerId) => {
    const response = await apiClient.get(`/brickbucket/discounts/get-discounts-by-customer?customerId=${customerId}`);
    return response.data || response;
  },

  applyDiscount: async (payload) => {
    const response = await apiClient.post('/brickbucket/discounts/apply-discount', payload);
    return response.data || response;
  },

  evaluateDiscounts: async (payload) => {
    const response = await apiClient.post('/brickbucket/discounts/evaluate-discounts', payload);
    return response.data || response;
  },

  removeDiscount: async (payload) => {
    const response = await apiClient.post('/brickbucket/discounts/remove-discount', payload);
    return response.data || response;
  },
};